export default __webpack_public_path__ + "static/ebook-mobile-4678cad41dcf9c9aa53e5208a19cfe07.png";